<template>
  <div id="app" class="layout">
    <!-- 사이드바 -->
    <aside
      class="sidebar"
      v-if="$route.name !== 'LoginPage'"
      :class="{ collapsed: isSidebarCollapsed }"
    >
      <div class="sidebar-logo">
        <img src="./assets/image/logo_row.png" style="height: 48px; width: auto; margin: 6% auto 0 auto;" />
        
        <!-- ✅ 사이드바 안, 오른쪽 중앙 토글 버튼 -->
        <div
          class="sidebar-toggle"
          @click="toggleSidebar"
        >
          <!-- {{ isSidebarCollapsed ? '>' : '<' }} -->
          <img v-if="isSidebarCollapsed" src="./assets/image/rightArrow.png" style="width: 100%; margin-top: 50%;" />
          <img v-else src="./assets/image/leftArrow.png" style="width: 100%; margin-top: 50%;" />
        </div>
      </div>

      <!-- 메뉴는 접혔을 때 안 보이게 -->
      <ul class="menu" v-show="!isSidebarCollapsed">

        <!-- 메인 -->
        <li
          class="menu-item dropdown"
          :class="{ open: isMainOpen }"
          @mouseenter="openMain()"
          @mouseleave="closeMain()"
          v-if="hasPermission('dataRead') || hasPermission('sensorTolerance') || hasPermission('workCondition') || roleCheckAdmin"
        >
          <router-link to="/" class="menu-link dropdown-toggle" exact>
            <span class="nav-icon dynamic-icon main-icon"></span>
            <span class="nav-label">메인</span>
            <span
              v-if="hasPermission('dataRead') || hasPermission('sensorTolerance') || hasPermission('workCondition') || roleCheckAdmin"
              class="arrow"
              :class="{ open: isMainOpen }"
            ></span>
          </router-link>
          <ul class="submenu" v-if="hasPermission('dataRead') || hasPermission('sensorTolerance') || hasPermission('workCondition') || roleCheckAdmin" v-show="isMainOpen">
            <li class="submenu-item" v-if="hasPermission('dataRead')">
              <router-link to="/dataread" class="submenu-link">
                <span class="nav-icon dynamic-icon data-read-icon"></span>
                <span class="nav-label">데이터 조회</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('sensorTolerance')">
              <router-link to="/sensorTolerance" class="submenu-link">
                <span class="nav-icon dynamic-icon gauge-icon"></span>
                <span class="nav-label">센서 경고 기준 설정</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('workCondition')">
              <router-link :to="{ name: 'WorkConditionWrite', query: { mode: 'active' } }" class="submenu-link">
                <span class="nav-icon dynamic-icon work_condition-icon"></span>
                <span class="nav-label">작업중</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 업체등록 -->
        <li class="menu-item" v-if="hasPermission('compRegist')">
          <router-link :to="compLink" class="menu-link">
            <span class="nav-icon dynamic-icon comp-register-icon"></span>
            <span class="nav-label">업체등록</span>
          </router-link>
        </li>

        <!-- 제품등록 -->
        <li class="menu-item" v-if="hasPermission('product')">
          <router-link :to="prodLink" class="menu-link">
            <span class="nav-icon dynamic-icon prod-register-icon"></span>
            <span class="nav-label">제품등록</span>
          </router-link>
        </li>

        <!-- 금형등록 -->
        <li class="menu-item" v-if="hasPermission('moldRegist')">
          <router-link to="/moldRegist" class="menu-link">
            <span class="nav-icon dynamic-icon mold-register-icon"></span>
            <span class="nav-label">금형등록</span>
          </router-link>
        </li>

        <!-- 드롭다운: 발주 -->
        <li
          class="menu-item dropdown"
          @mouseenter="openOrder"
          @mouseleave="closeOrder"
          :class="{ open: isOrderOpen }"
          v-if="hasPermission('customerOrder')"
        >
          <div class="menu-link dropdown-toggle">
            <span class="nav-icon dynamic-icon custom-icon"></span>
            <span class="nav-label">발주</span>
            <span class="arrow" :class="{ open: isOrderOpen }"></span>
          </div>
          <ul class="submenu" v-show="isOrderOpen">
            <li class="submenu-item" v-if="hasPermission('customerOrder')">
              <router-link to="/shipmentSchedule" class="submenu-link">
                <span class="nav-icon dynamic-icon shipment-schedule-icon"></span>
                <span class="nav-label">출하일정</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('customerOrder')">
              <router-link to="/customerOrder" class="submenu-link">
                <span class="nav-icon dynamic-icon custom-icon"></span>
                <span class="nav-label">고객발주등록</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 드롭다운: 빌렛 -->
        <li
          class="menu-item dropdown"
          @mouseenter="openBillet"
          @mouseleave="closeBillet"
          :class="{ open: isBilletOpen }"
          v-if="hasPermission('billetArrival') || hasPermission('billetIngredCriteria') || hasPermission('incomingInsp')"
        >
          <div class="menu-link dropdown-toggle">
            <span class="nav-icon dynamic-icon billet-icon"></span>
            <span class="nav-label">빌렛</span>
            <span class="arrow" :class="{ open: isBilletOpen }"></span>
          </div>
          <ul class="submenu" v-show="isBilletOpen">
            <li class="submenu-item" v-if="hasPermission('billetIngredCriteria')">
              <router-link to="/billetingredcriteria" class="submenu-link">
                <span class="nav-icon dynamic-icon ingred-icon"></span>
                <span class="nav-label">빌렛성분기준표</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('incomingInsp')">
              <router-link to="/incominginsp" class="submenu-link">
                <span class="nav-icon dynamic-icon incoming-icon"></span>
                <span class="nav-label">수입검사</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('billetArrival')">
              <router-link to="/billetarrival" class="submenu-link">
                <span class="nav-icon dynamic-icon arrival-icon"></span>
                <span class="nav-label">빌렛입고</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 드롭다운: 압출생산 -->
        <li
          class="menu-item dropdown"
          @mouseenter="openExtrusion"
          @mouseleave="closeExtrusion"
          :class="{ open: isExtrusionOpen }"
          v-if="hasPermission('productionOrder') || hasPermission('workCondition')"
        >
          <div class="menu-link dropdown-toggle">
            <span class="nav-icon dynamic-icon extrusion-icon"></span>
            <span class="nav-label">압출생산</span>
            <span class="arrow" :class="{ open: isExtrusionOpen }"></span>
          </div>
          <ul class="submenu" v-show="isExtrusionOpen">
            <li class="submenu-item" v-if="hasPermission('productionOrder')">
              <router-link to="/productionOrderLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon order-icon"></span>
                <span class="nav-label">생산지시서</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('workCondition')">
              <router-link to="/workConditionLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon work_condition-icon"></span>
                <span class="nav-label">압출작업일보</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 드롭다운: 열처리 -->
        <li
          class="menu-item dropdown"
          @mouseenter="openHeatTreat"
          @mouseleave="closeHeatTreat"
          :class="{ open: isHeatTreatOpen }"
          v-if="hasPermission('heatTreatWait') || hasPermission('heatTreatment')"
        >
          <div class="menu-link dropdown-toggle">
            <span class="nav-icon dynamic-icon heat_treat-icon"></span>
            <span class="nav-label">열처리</span>
            <span class="arrow" :class="{ open: isHeatTreatOpen }"></span>
          </div>
          <ul class="submenu" v-show="isHeatTreatOpen">
            <li class="submenu-item" v-if="hasPermission('heatTreatWait')">
              <router-link to="/heatTreatWaitLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon heat-treat-wait-icon"></span>
                <span class="nav-label">열처리대기</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('heatTreatment')">
              <router-link to="/heatTreatmentLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon heat_treat-icon"></span>
                <span class="nav-label">열처리일보</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 드롭다운: 재고관리 -->
        <li
          class="menu-item dropdown"
          @mouseenter="openInventory"
          @mouseleave="closeInventory"
          :class="{ open: isInventoryOpen }"
          v-if="hasPermission('extrusionComp') || hasPermission('productWarehouse') || hasPermission('productShipment')"
        >
          <div class="menu-link dropdown-toggle">
            <span class="nav-icon dynamic-icon inventory-icon"></span>
            <span class="nav-label">재고관리</span>
            <span class="arrow" :class="{ open: isInventoryOpen }"></span>
          </div>
          <ul class="submenu" v-show="isInventoryOpen">
            <li class="submenu-item" v-if="hasPermission('extrusionComp')">
              <router-link to="/extrusionCompLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon extrusion-comp-icon"></span>
                <span class="nav-label">압출생산완료</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('productWarehouse')">
              <router-link to="/productWarehouseLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon product-warehouse-icon"></span>
                <span class="nav-label">제품창고</span>
              </router-link>
            </li>
            <li class="submenu-item" v-if="hasPermission('productShipment')">
              <router-link to="/productShipmentLayout" class="submenu-link">
                <span class="nav-icon dynamic-icon product-shipment-icon"></span>
                <span class="nav-label">제품출하</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 드롭다운: 유저관리 -->
        <li
          class="menu-item dropdown"
          @mouseenter="openAdmin"
          @mouseleave="closeAdmin"
          :class="{ open: isAdminOpen }"
          v-if="roleCheckAdmin"
        >
          <div class="menu-link dropdown-toggle">
            <span class="nav-icon dynamic-icon page-admin-icon"></span>
            <span class="nav-label">페이지 관리</span>
            <span class="arrow" :class="{ open: isAdminOpen }"></span>
          </div>
          <ul class="submenu" v-show="isAdminOpen">
            <li class="submenu-item">
              <router-link to="/adminpage" class="submenu-link">
                <span class="nav-icon dynamic-icon admin-icon"></span>
                <span class="nav-label">유저관리</span>
              </router-link>
            </li>
            <li class="submenu-item">
              <router-link to="/logPage" class="submenu-link">
                <span class="nav-icon dynamic-icon log-icon"></span>
                <span class="nav-label">이력조회</span>
              </router-link>
            </li>
          </ul>
        </li>

      </ul>
      <div class="logOutClass">
        <img src="./assets/image/logOut.png" @click.prevent="logOut()" style="width: 15%;" alt="">
      </div>
    </aside>

    <!-- 오른쪽 화면 -->
    <main class="content">
      <router-view />
    </main>
  </div>
</template>


<script>
export default {
  name: 'App',
  data () {
    return {
      isBilletOpen: false,
      isOrderOpen: false,
      isExtrusionOpen: false,
      isHeatTreatOpen: false,
      isInventoryOpen: false,
      isAdminOpen: false,
      isSidebarCollapsed: false,
      isMainOpen: false,
    }
  },
  computed: {
    currentUser() {
        return this.$store.state.auth.user;
    },
    roleCheckAdmin() {
        if (this.currentUser && this.currentUser.roles) {
            return this.currentUser.roles.includes('ROLE_ADMIN');
        }
        return false
    },
    userPermissions() {
        if (!this.currentUser || !this.currentUser.permissions) return {};
        try {
          const p = JSON.parse(this.currentUser.permissions);
          if (Array.isArray(p)) {
            const obj = {};
            p.forEach(k => { obj[k] = 'write'; });
            return obj;
          }
          return p;
        } catch { return {}; }
    },
    compLink() {
      const path = this.$route.path; // 예: "/compRegist/vendor"
      if(path === '/compRegist/vendor' || path === '/compRegist/type') {
        return path;
      }else {
        return '/compRegist/:tab?'
      }

    },
    prodLink() {
      const path = this.$route.path; // 예: "/compRegist/vendor"
      if(path === '/product/register' || path === '/product/process') {
        return path;
      }else {
        return '/product/:tab?'
      }

    }
  },
  methods: {
    hasPermission(key) {
      if (!this.currentUser) return false;
      if (this.roleCheckAdmin) return true;
      return Object.prototype.hasOwnProperty.call(this.userPermissions, key);
    },
    openMain() {
      this.isMainOpen = true
    },
    closeMain() {
      this.isMainOpen = false
    },
    openBillet() {
      this.isBilletOpen = true
    },
    closeBillet() {
      this.isBilletOpen = false
    },
    openOrder() {
      this.isOrderOpen = true
    },
    closeOrder() {
      this.isOrderOpen = false
    },
    goBillet() {
      if (this.$route.path !== '/billet') {
        this.$router.push('/billet')
      }
    },
    openExtrusion() {
      this.isExtrusionOpen = true
    },
    closeExtrusion() {
      this.isExtrusionOpen = false
    },
    openHeatTreat() {
      this.isHeatTreatOpen = true
    },
    closeHeatTreat() {
      this.isHeatTreatOpen = false
    },
    openInventory() {
      this.isInventoryOpen = true
    },
    closeInventory() {
      this.isInventoryOpen = false
    },
    openAdmin() {
      this.isAdminOpen = true
    },
    closeAdmin() {
      this.isAdminOpen = false
    },
    goExtrusion() {
      if (this.$route.path !== '/extrusion') {
        this.$router.push('/extrusion')
      }
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed
    },
    logOut() {
      if(confirm('로그아웃 하시겠습니까?')) {
        alert('로그아웃했습니다.');
        this.$store.dispatch("auth/logout")
        this.$router.push("/login")
      }
    },
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
  font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  position: relative;
}

/* 사이드바 – 400px 유지 */
.sidebar {
  width: 270px;
  background-color: #ffffff;
  border-right: 1px solid #eeeeee;
  display: flex;
  flex-direction: column;
  position: sticky;                /* 스크롤 시 화면에 고정 */
  top: 0;
  height: 100vh;
  flex-shrink: 0;
  overflow-x: hidden;              /* 접힘 애니메이션용 */
  overflow-y: auto;                /* 메뉴가 많을 때 사이드바 내부 스크롤 */
  transition: width 0.25s ease;
}

/* ✅ 접힌 상태: 완전히 왼쪽으로 숨김 */
.sidebar.collapsed {
  width: 40px;
}

/* 접혔을 때 로고도 숨김 (menu는 v-show로 이미 숨김) */
.sidebar.collapsed > .sidebar-logo > img {
  display: none;
}

.sidebar.collapsed > .sidebar-logo > .sidebar-toggle {
  position: static;
}

.sidebar.collapsed > .sidebar-logo > .sidebar-toggle > img {
  /* left: 5px; */
  margin-left: 20px;
}

/* 사이드바 토글 버튼 */
.sidebar-toggle {
  /* position: absolute;
  top: 50%; */
  position: absolute;
  right: 0;
  top: 25px;
  /* transform: translateY(-50%); */
  width: 24px;
  height: 48px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}


/* 눌렀을 때 살짝 효과 */
.sidebar-toggle:active {
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15) inset;
}

/* ✅ 사이드바가 접힌 상태일 때 토글 버튼을 화면 맨 왼쪽에 */
.layout.sidebar-collapsed .sidebar-toggle {
  left: 0;
}

/* 사이드바가 접힌 상태라도 오른쪽 content는 flex로 자동 확장됨 */
/* 필요 시 시각적으로만 너비 조정 */
.layout.sidebar-collapsed .content {
  width: 100%;
}

.sidebar-logo {
  height: 40px;
  width: 100%;
  padding: 25px 0 0 0;
  position: relative;
  display: flex;
  align-items: center;
}

.menu {
  list-style: none;
  margin: 40px 0 0 0;
  padding: 0;
}

/* 메뉴 아이템 */
.menu-item {}

/* 상위 메뉴 링크 – 높이는 padding으로 통일 */
.menu-link {
  display: flex;
  align-items: center;
  padding: 22px 32px;
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: bolder;
  cursor: pointer;
  background-color: #ffffff;
}

.menu-link:hover {
  background-color: #f9e8ec;
  color: #5c0427;
}

/* 아이콘 공통 */
.nav-icon {
  width: 22px;
  height: 22px;
  margin-right: 12px;
  display: inline-block;
}

/* ✅ 아이콘 공통: CSS 변수로 기본/활성 이미지 적용 */
.dynamic-icon {
  background-image: var(--icon-default);
  background-size: contain;
  background-repeat: no-repeat;
}

/* ✅ hover & 활성(router-link-active) 시 활성 아이콘 사용 */
.menu-link:hover .dynamic-icon,
.menu-link.router-link-exact-active .dynamic-icon,
.menu-link.router-link-active .dynamic-icon,
.submenu-link:hover .dynamic-icon,
.submenu-link.router-link-exact-active .dynamic-icon,
.submenu-link.router-link-active .dynamic-icon {
  background-image: var(--icon-active);
}

/* ✅ 각 탭별 아이콘 파일 지정 */
.main-icon {
  --icon-default: url('./assets/image/main_b.png');
  --icon-active: url('./assets/image/main_p.png');
}

.prod-register-icon {
  --icon-default: url('./assets/image/prod_register_b.png');
  --icon-active: url('./assets/image/prod_register_p.png');
}

.custom-icon {
  --icon-default: url('./assets/image/custom_b.png');
  --icon-active: url('./assets/image/custom_p.png');
}

.shipment-schedule-icon {
  --icon-default: url('./assets/image/arrival_b.png');
  --icon-active: url('./assets/image/arrival_p.png');
}

.comp-register-icon {
  --icon-default: url('./assets/image/comp_b.png');
  --icon-active: url('./assets/image/comp_p.png');
}

.mold-register-icon {
  --icon-default: url('./assets/image/mold_plus_b.png');
  --icon-active: url('./assets/image/mold_plus_p.png');
}

.mold-icon {
  --icon-default: url('./assets/image/mold_b.png');
  --icon-active: url('./assets/image/mold_p.png');
}

.billet-icon {
  --icon-default: url('./assets/image/billet_b.png');
  --icon-active: url('./assets/image/billet_p.png');
}

.extrusion-icon {
  --icon-default: url('./assets/image/extrusion_b.png');
  --icon-active: url('./assets/image/extrusion_p.png');
}

.data-read-icon {
  --icon-default: url('./assets/image/data_read_b.png');
  --icon-active: url('./assets/image/data_read_p.png');
}

.admin-icon {
  --icon-default: url('./assets/image/admin_b.png');
  --icon-active: url('./assets/image/admin_p.png');
}

.page-admin-icon {
  --icon-default: url('./assets/image/page_admin_b.png');
  --icon-active: url('./assets/image/page_admin_p.png');
}

.log-icon {
  --icon-default: url('./assets/image/admin_b.png');
  --icon-active: url('./assets/image/admin_p.png');
}

.gauge-icon {
  --icon-default: url('./assets/image/gauge_b.png');
  --icon-active: url('./assets/image/gauge_p.png');
}

.ingred-icon {
  --icon-default: url('./assets/image/ingr_check_b.png');
  --icon-active: url('./assets/image/ingr_check_p.png');
}

.order-icon {
  --icon-default: url('./assets/image/order_b.png');
  --icon-active: url('./assets/image/order_p.png');
}

.arrival-icon {
  --icon-default: url('./assets/image/arrival_b.png');
  --icon-active: url('./assets/image/arrival_p.png');
}

.work_condition-icon {
  --icon-default: url('./assets/image/work_condition_b.png');
  --icon-active: url('./assets/image/work_condition_p.png');
}

.incoming-icon {
  --icon-default: url('./assets/image/incoming_b.png');
  --icon-active: url('./assets/image/incoming_p.png');
}

.heat_treat-icon {
  --icon-default: url('./assets/image/heat_treat_b.png');
  --icon-active: url('./assets/image/heat_treat_p.png');
}

.inventory-icon {
  --icon-default: url('./assets/image/order_b.png');
  --icon-active: url('./assets/image/order_p.png');
}

.extrusion-comp-icon {
  --icon-default: url('./assets/image/work_condition_b.png');
  --icon-active: url('./assets/image/work_condition_p.png');
}

.heat-treat-wait-icon {
  --icon-default: url('./assets/image/work_condition_b.png');
  --icon-active: url('./assets/image/work_condition_p.png');
}

.product-warehouse-icon {
  --icon-default: url('./assets/image/order_b.png');
  --icon-active: url('./assets/image/order_p.png');
}

.product-shipment-icon {
  --icon-default: url('./assets/image/shipment_b.png');
  --icon-active: url('./assets/image/shipment_p.png');
}

.log-icon {
  --icon-default: url('./assets/image/log_b.png');
  --icon-active: url('./assets/image/log_p.png');
}

.nav-label {
  flex: 1;
}

/* router-link 활성 스타일 */
.menu-link.router-link-exact-active,
.menu-link.router-link-active {
  background-color: #f9e8ec;
  border-left: 8px solid #5c0427;
  color: #5c0427;
  padding-left: 24px;
}
.dropdown.disabled .submenu {
  display: none !important;
}
/* 드롭다운 open 시 빌렛투입에도 동일한 활성 스타일 적용 */
.dropdown.open > .menu-link {
  background-color: #f9e8ec;
  border-left: 8px solid #5c0427;
  color: #5c0427;
  padding-left: 24px;
}

/* 드롭다운 open 시 아이콘도 활성 아이콘으로 */
.dropdown.open > .menu-link .dynamic-icon {
  background-image: var(--icon-active);
}

/* 드롭다운 */
.dropdown {
  position: relative;
}

/* 화살표 */
.dropdown-toggle .arrow {
  width: 8px;
  height: 8px;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
  transform: rotate(45deg);
  transition: transform 0.2s;
  margin-left: 8px;
}

.dropdown-toggle .arrow.open {
  transform: rotate(135deg);
}

/* 서브메뉴 */
.submenu {
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: #ffffff;
}

/* 서브메뉴 링크 */
.submenu-link {
  display: flex;
  align-items: center;
  padding: 22px 32px 22px 56px;
  font-size: 14px;
  color: #555;
  text-decoration: none;
  background-color: #ffffff;
}

/* 서브메뉴 hover 시 연보라 */
.submenu-link:hover {
  background-color: #f9e8ec;
  color: #5c0427;
}

/* 서브메뉴 활성화(현재 라우트) */
.submenu-link.router-link-exact-active,
.submenu-link.router-link-active {
  background-color: #f9e8ec;
  color: #5c0427;
  font-weight: 600;
}

/* 오른쪽 컨텐츠 */
.content {
  flex: 1;
  width: 70%;
  background-color: #f5f5f5;
}
.logOutClass {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
}
.logOutClass > img {
  /* padding-top: 255%; */
  /* display: flex;
  align-items: flex-end; */
  margin-left: 20px;
  margin-bottom: 20px;
}


</style>

<!-- 전역 스타일 (scoped 아님) -->
<style>
@keyframes rowFlash {
  0%   { background-color: #ffe066 !important; }
  60%  { background-color: #ffe066 !important; }
  100% { background-color: transparent !important; }
}
.row-highlight-flash {
  animation: rowFlash 2.5s ease-out forwards !important;
}
</style>
